import { StyleSheet, css } from 'aphrodite';
import { AppTheme } from '../../styles/AppTheme';
import { ColourPalette } from  '../../styles/AppColourPalette';

export const Styles = StyleSheet.create({
  headerOrgOuterContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    justifyContent: 'center',
    marginRight: 10
  },
  selectIcon: {
    color: AppTheme.white
  },
  selectCheckbox: {
    color: AppTheme.white
  },
  buttonContainer: {
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginTop: 5
  },
  buttonStyle: {
    marginRight: 8,
    backgroundColor: ColourPalette.color3,
    borderRadius: 4,
    color: AppTheme.white,
    fontWeight: 'bold',
    fontSize: 11,
    padding: '5px 16px'
  },
  buttonStyleApply: {
    marginRight: 0,
    fontSize: 13,
  },
  buttonStyleUpload: {
    marginRight: 0,
    marginLeft: 20,
    height: 39,
    fontSize: 12
  },
  inputCssTextField: {
    flex: .6,
    color: AppTheme.white
  },
  headerTextFieldContentInput: {
    borderRadius: 4,
    backgroundColor: AppTheme.secondaryColor,
    paddingLeft: 8,
    color: AppTheme.white,
  },
  headerTextFieldContent: {
    color: AppTheme.white,
    zIndex: 1,
    paddingLeft: 8,
    opacity: .6
  },
  menuHeaderRoleConatiner: {
    backgroundColor: ColourPalette.color1,
    color: AppTheme.primaryColor,
    marginRight: 10,
    borderRadius: 5,
    padding: 4,
    display: 'flex',
    alignItems: 'center',
  },
  menuHeaderRoleStyleConatiner: {
    backgroundColor: AppTheme.primaryColor,
    color: 'rgb(255,255,255,0.6)'
  },
  menuHeaderRole: {
    margin: 0,
    fontSize: 13,
    fontWeight: 'bold',
    cursor: 'pointer'
  },
  tagFilterOuterContainer: {
    flex: 1,
    margin: '10px 0px'
  },
  tagFilterContainer: {
    display: 'flex'
  },
  headerTagContainer: {
    flex: .4,
    display: 'flex',
    justifyContent: 'flex-start'
  },
  gridImg: {
    marginRight: 0
  },
  formControlSwitch: {
    width: 55,
    margin: '0px 3px'
  },
  sliderContainer: {
    width: 55,
    padding: 0,
    height: 4
  },
  selectOrgMenu: {
    minWidth: 150,
    backgroundColor: AppTheme.secondaryColor,
    color: AppTheme.white,
    fontSize: 15,
    padding: 7,
    display: 'flex',
    alignItems: 'center',
    borderRadius: 5,
    border: '1px solid ' + AppTheme.secondaryColor,
    ':hover' : {
      border: '1px solid ' + ColourPalette.color3
    },
    '@media(max-width: 768px)': {
      minWidth: 'unset'
    }
  },
  headerMemberAddContainerSecond: {
    justifyContent: 'flex-start',
    padding: 0,
    paddingLeft: 10,
    paddingRight: 10,
    '@media(max-width: 768px)': {
      marginTop: 10,
      paddingRight: 0,
      justifyContent: 'center',
    }
  },
  headerMemberStyle: {
    justifyContent: 'flex-start',
    padding: 0,
    paddingLeft: 10,
    paddingRight: 10,
    marginRight: 10,
    '@media(max-width: 768px)': {
      marginTop: 10,
      marginRight: 0,
      paddingRight: 0,
      justifyContent: 'center',
    }
  },
  headerMemberMobileStyle: {
    '@media(max-width: 768px)': {
      display: 'none'
    }
  },
  dateContainer: {
    fontSize: 14,
    color: AppTheme.white,
    margin: 0,
    '@media(max-width: 768px)': {
      flex: 1
    }
  },
  pickerInnerContainer: {
    color: AppTheme.white,
    marginRight: 10,
    '@media (max-width: 768px)': {
      //marginTop: 10,
      marginRight: 0,
    }
  },
  input: {
    cursor: 'pointer'
  },
  dateControlImg: {
    opacity: .7,
    marginRight: 8
  },
  dateInputCss: {
    marginTop: 8,
    color: 'white'
  },
  dateControlLabel: {
    padding: 15,
    display: 'flex',
    flexDirection: 'column'
  },
  dateClose: {
    marginLeft: 5,
    display: 'flex',
    alignItems: 'center',
    width: 20
  },
  menuItemPopoverContainer: {
    minWidth: 300,
    marginTop: 5,
    '@media (max-width: 768px)': {
      minWidth: 'unset',
      width: '-webkit-fill-available'
    }
  },
  formControlLabelContainer: {
    margin: 0,
    height: AppTheme.actionHeaderbarHeight
  },
  switchControlLabelChecked: {
    padding: 10,
    color: ColourPalette.color3,
  },
  switchControlLabelThumb: {
    width: 18,
    height: 18
  },
  switchControlLabeltrack: {
    backgroundColor: ColourPalette.color3
  },
  switchControlLabel: {
    color: AppTheme.white,
    margin: 0,
    fontSize: 14,
    opacity: 0.6
  },
  filterPopoverContainer: {
    backgroundColor: AppTheme.primaryBackground,
    borderRadius: 4,
    maxWidth: 350,
    marginTop: 10,
    '@media (max-width: 767px)': {
      maxWidth: '91%'
    }
  },
  filterContainerHeader: {
    backgroundColor: AppTheme.white
  },
  filterContentHeader: {
    margin: 0,
    padding: 20,
    color: AppTheme.primaryBackground,
    fontSize: AppTheme.fontSizeTitle,
    cursor: 'default'
  },
  divider: {
    backgroundColor: '#626F8A'
  },
  saveFilterContainer: {
    fontSize: 13,
    display: 'flex',
    alignItems: 'center',
    color: 'white',
    opacity: 0.8
  },
  filterContent: {
    padding: 20
  },
  filterInnerContent: {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: 20
  },
  filterIncidentTitle: {
    opacity: 0.6,
    color: AppTheme.white,
    fontSize: AppTheme.fontSizeContent,
    margin: 0,
    marginTop: 10,
    marginBottom: 5,
    cursor: 'default'
  },
  editAlertTag: {
    flexDirection:'column'
  },
  headerEditAlertContainer: {
    marginTop: 10,
  },
  headerEditAlertDotContainer: {
    borderRadius: '4px 0px 0px 4px'
  },
  headerEditAlertLabel: {
    borderRadius: '0px 4px 4px 0px'
  },

  link: {
    textDecoration: 'none'
  },
  innerContainer: {
    width: '90%',
    display: 'flex',
    paddingTop: 20
  },
  inputCss: {
    margin: 0,
    flex: 1,
    color: AppTheme.white,
    width : '100%'
  },
  inputCssText: {
    margin: 0
  },
  textFieldContentInput: {
    borderRadius: 4,
    backgroundColor: AppTheme.secondaryColor,
    // paddingLeft: 8,
    color: AppTheme.white,
    height: 30,
    padding: 5
  },
  textFieldContentInputText: {
    paddingLeft: 8
  },
  editTextFieldContentInput: {
    borderRadius: 4,
    color: AppTheme.white,
  },
  textFieldContent: {
    color: AppTheme.white,
    zIndex: 1,
    opacity: .6
  },
  innerEventListContainer: {
    width: window.innerWidth * 0.9 * 0.14, //TODO
    maxHeight: 900,
    padding: 5,
    paddingTop: 30,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: AppTheme.primaryColor,
    alignItems: 'center',
    '@media(max-width: 768px)': {
      display: 'none'
    }
  },
  innerEventListContainerRelativeOpen: {
    width: window.innerWidth * 0.9 * 0.14, //TODO
    maxHeight: 900,
    padding: 5,
    display: 'flex',
    flexDirection: 'column',
    borderRight: '1px solid #374056',
    opacity: .1,
    zIndex: 1,
    backgroundColor: AppTheme.primaryColor,
    pointerEvents: 'none',
    '@media(max-width: 768px)': {
      display: 'none'
    }
  },
  innerSearchContainer: {
    border: '1px solid #354058',
    borderRadius: 4,
    width: '85%'
  },
  innerSearchContent: {
    color: AppTheme.white,
    fontSize: AppTheme.fontSizeContent,
    opacity: .6,
    cursor: 'default',
    margin: '10px 0px',
    textAlign: 'center'
  },
  innerEventListContent: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'scroll',
    padding: 15,
    width: '85%'
  },
  eventListContent: {
    //display: 'flex',
    flexDirection: 'column',
    border: '2px solid ' + AppTheme.secondaryColor,
    marginBottom: 20,
    marginTop: 10,
    cursor: 'pointer',
    //minHeight: 125,
    ':hover': {
      border: '2px solid #5B4EF7',
    },
  },
  eventListStackContent: {
    //display: 'flex',
    flexDirection: 'column',
    border: '2px solid ' + AppTheme.secondaryColor,
    marginBottom: 20,
    marginTop: 10,
    cursor: 'pointer',
    //minHeight: 125,
    ':hover': {
      border: '2px solid #5B4EF7',
    },
    boxShadow: '0 0px 0px rgba(0,0,0,0.15),4px 4px 1px ' + AppTheme.primaryBackground + ',7px 7px 0px -1px rgba(0,0,0,0.3), 10px 10px 1px ' + AppTheme.primaryBackground
  },
  eventListImageConatiner: {
    width: '100%',
    /*height: 50,*/
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: AppTheme.black
  },
  eventImg: {
    width: '100%'
  },
  eventListTitleConatiner: {
    backgroundColor: AppTheme.primaryBackground,
    color: AppTheme.white,
    padding: 5,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    whiteSpace: 'nowrap'
  },
  eventListTitleConatinerCust: {
    padding: 5,
    overflow: 'hidden'
  },
  eventListTitle: {
    margin: 0,
    fontSize: 13,
    whiteSpace: 'pre-wrap'
  },
  eventListTitleCust: {
    fontSize: 10,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  eventListDateContainer: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 5,
  },
  eventListDate: {
    flex: 1,
    margin: 0,
    fontSize: 11,
    opacity: 0.6,
    whiteSpace: 'pre-wrap'
  },
  eventListDateCust: {
    fontSize: 9,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  eventImageLoading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 40,
    color: AppTheme.white,
    opacity: 0.6
  },

  eventItemOuterContainer: {
    display: 'flex',
    width: window.innerWidth * .9 * .84, //TODO
    alignItems: 'flex-start',
    '@media(max-width: 768px)': {
      flexDirection: 'column',
      width: '100%',
      alignItems: 'center',
    }
  },
  eventItemHeaderContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '30px',
    width: window.innerWidth * .9 * .84 * .64, //TODO
    position: 'relative',
    marginLeft: 10,
    marginRight: 10,
    backgroundColor: AppTheme.primaryColor,
    '@media(max-width: 768px)': {
      width: '100%',
      padding: 10,
      margin: 0,
    }
  },
  eventItemHeaderContent: {
    display: 'flex',
    position: 'relative'
  },
  eventHeaderOuterContent: {
    display: 'flex',
  },
  eventItemHeaderInnerContent: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1
  },
  eventItemHeaderSearchInnerContent: {
    display: 'none',
    '@media(max-width: 768px)': {
      display: 'flex',
      border: '1px solid #354058',
      borderRadius: 4,
      width: '100%',
      marginBottom: 10
    }
  },
  eventItemTime: {
    color: AppTheme.white,
    opacity: 0.3,
    margin: 0,
    fontSize: 11,
    cursor: 'default'
  },
  eventItemTitle: {
    color: AppTheme.white,
    opacity: 0.7,
    fontSize: 20,
    margin: 0,
    marginTop: 8,
    cursor: 'default'
  },
  eventItemInnerContent: {
    display: 'flex',
    cursor: 'default',
    '@media (max-width: 767px)': {
      flexDirection: 'column'
    }
  },
  eventItemOuterTagContent: {
    flex: 0.3,
    marginTop: 10
  },
  eventItemInnerTagContent: {
    display: 'flex',
  },
  eventItemType: {
    border: '1px solid #354058',
    padding: 5,
    fontSize: AppTheme.fontSizeContent,
    color: '#C7C9CB',
    borderRadius: 4,
    marginRight: 8,
    cursor: 'default',
    maxWidth: 'fit-content'
  },
  eventItemTypePriority: {
    border: '1px solid #F5A623',
    borderRadius: 4,
  },
  eventLiveFeed: {
    position: 'absolute',
    top: 80,
    right: 20,
    display: 'flex',
    cursor: 'pointer',
    '@media (max-width: 768px)': {
      top: '25vh',
      right: 0,
    }
  },
  eventRelativeLiveFeed: {
    top: 120,
    right: 25,
    zIndex: 1
  },
  eventLiveFeedContainer: {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-end',
    alignItems: 'center',
    cursor: 'pointer',
  },
  eventLiveFeedContent: {
    border: '1px solid #354058',
    borderRadius: 4,
    padding: '10px 15px',
    fontSize: AppTheme.fontSizeContent,
    fontWeight: 'bold',
    opacity: 0.6,
    color: AppTheme.white,
    '@media (max-width: 767px)': {
      fontSize: 11,
      padding: '10px 10px',
    }
  },
  eventImageContent: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    //backgroundColor: AppTheme.black,
    alignItems: 'center',
    margin: '20px 0px'
  },
  relativeSettings: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    //marginLeft: 25
  },
  relativeSettingsWithMargin: {
    display: 'flex',
    width: '100%',
    marginLeft: 25,
  },
  editImageDialog: {
    margin: 0
  },
  eventImageConatiner: {
    marginTop: 10
  },
  eventImage: {
    width: '100%',
  },
  filterIcon: {
    marginRight: 8,
  },
  eventRelativeImage: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    cursor: 'pointer',
    outline: 'unset',
  },
  eventRelativeImageLess: {
    justifyContent: 'flex-start',
    width: 130
  },
  highlightRelative: {
    border: '1px solid #5B4EF7'
  },
  eventRelativeImageContent: {
    //maxWidth: 130,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: AppTheme.primaryBackground,
    border: '2px solid' + AppTheme.secondaryColor,
  },
  relativeImageContent: {
    maxWidth: '100%'
  },
  eventControlContent: {
    display: 'flex',
    justifyContent: 'center',
  },
  eventControlContentRelativeOpen: {
    display: 'flex',
    justifyContent: 'center',
    opacity: .1,
    zIndex: 1,
    backgroundColor: AppTheme.secondaryColor,
    pointerEvents: 'none'
  },
  eventInnerControlContent: {
    display: 'flex',
  },
  eventInnerControl: {
    display: 'flex',
    flexDirection: 'column',
    width: 43,
    marginRight: 40,
    alignItems: 'center',
    '@media(max-width: 768px)': {
      marginRight: 20,
      marginLeft: 20
    }
  },
  eventInnerControlImgConatinerLast: {
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 8,
    width: 30,
    height: 30,
    cursor: 'default',
    backgroundColor: ColourPalette.color2,
    pointerEvents: 'none',
    '@media(max-width: 768px)': {
      width: 20,
      height: 20,
    }
  },
  eventInnerControlImgConatiner: {
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 8,
    width: 30,
    height: 30,
    cursor: 'pointer',
    ':hover': {
      backgroundColor: ColourPalette.color2,
    },
    '@media(max-width: 768px)': {
      width: 20,
      height: 20,
    }
  },
  eventPlayerIcon: {
    color: AppTheme.white,
    opacity: 0.6,
    fontSize: 40,
    '@media(max-width: 768px)': {
      fontSize: 30,
    }
  },
  controlImg: {
    width: '100%'
  },
  eventInnerControlImgTitle: {
    fontSize: 10,
    opacity: .3,
    color: AppTheme.white,
    textAlign: 'center',
    marginTop: 6,
    cursor: 'default'
  },
  eventItemHeaderConatinerRelativeOpen: {
    opacity: .1,
    zIndex: 1,
    backgroundColor: AppTheme.secondaryColor,
    pointerEvents: 'none',
  },
  eventItemHeaderConatinerRelativeClose: {
    display: 'flex',
    flexDirection: 'column'
  },
  eventItemFeatureContainer: {
    width: window.innerWidth * .9 * .84 * .3, //TODO
    backgroundColor: AppTheme.primaryColor,
    padding: 5,
    paddingTop: 30,
    paddingBottom: 30,
    //marginTop: 103,
    '@media(max-width: 768px)': {
      width: '100%',
      marginTop: 20,
      marginBottom: 30,
      padding: 0,
      paddingTop: 15,
      paddingBottom: 15
    }
  },
  eventItemFeatureContainerRelativeOpen : {
    width: window.innerWidth * .9 * .84 * .3, //TODO
    opacity: .1,
    zIndex: 1,
    marginTop: 103,
    pointerEvents: 'none',
    backgroundColor: AppTheme.primaryColor,
    padding: 5,
    paddingTop: 30,
    paddingBottom: 30,
  },
  relatedImageHeaderContainer: {
    display: 'flex',
    padding: '30px 0px 10px 0px',
    cursor: 'default'
  },
  relatedImageTitile: {
    color: '#99A0AF',
    fontSize: AppTheme.fontSizeContent,
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    cursor: 'deafult',
    marginLeft: 26
  },
  relatedImageSelectionContent: {
    width: 24,
    height: 24,
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    cursor: 'pointer',
    ':hover': {
      backgroundColor: '#1D2331'
    }
  },
  relatedImageSelectionLess: {
    pointerEvents: 'none',
    ':hover': {
      backgroundColor: AppTheme.secondaryColor
    }
  },
  eventEditOuterContainer: {
    display: 'flex',
    marginLeft: 25,
    marginRight: 25,
  },
  eventEditContainer: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  eventEditContainerStyle: {
    marginTop: 0,
    flex: 1,
    justifyContent: 'flex-end'
  },
  eventEditImgContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginRight: 10
  },
  eventEditImg: {
    display: 'flex',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  eventEdit: {
    margin: 0,
    fontSize: AppTheme.fontSizeContent,
    '@media(max-width: 768px)': {
      fontSize: 11
    }
  },
  dialog: {
    minWidth: 600,
    '@media(max-width: 768px)': {
      minWidth: '-webkit-fill-available',
      margin: 5
    }
  },
  scrollPaper: {
    justifyContent: 'center',
    '@media(max-width: 768px)': {
      overflow: 'scroll',
      justifyContent: 'flex-start'
    }
  },
  dialogTitle: {
    backgroundColor: AppTheme.white,
    padding: 20,
  },
  dialogTitleContainer: {
    display: 'flex'
  },
  dialogTitleContent: {
    margin: 0,
    fontSize: AppTheme.fontSizeTitle,
    cursor: 'default',
    fontWeight: 600,
  },
  closeIconContainer: {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-end',
    alignItems: 'center',
    cursor: 'pointer'
  },
  dialogContent: {
    padding: 20,
    paddingBottom: 0,
    backgroundColor: AppTheme.primaryBackground,
  },
  fieldsContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  statAdjustInfo: {
    marginBottom: 25
  },
  statAdjustContainerTitle: {
    margin: 0,
    marginBottom: 10,
    fontWeight: 'bold',
    fontSize: 15,
    color: AppTheme.white,
    cursor: 'default',
    opacity: .7,
  },
  statAdjustVal: {
    margin: 0,
    fontSize: 15,
    color: AppTheme.white,
    fontWeight: 'bold',
  },
  dialogActions: {
    alignItems: 'flex-end',
    padding: 20,
    display: 'flex',
    justifyContent: 'flex-end',
    backgroundColor: AppTheme.primaryBackground,
  },
  actionButton: {
    backgroundColor: ColourPalette.color3,
    color: AppTheme.white,
    fontWeight: 'bolder',
    margin: 0,
    fontSize: AppTheme.fontSizeTitle,
    textTransform: 'unset',
    marginLeft: 15,
    padding: '0px 16px'
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative'
  },
  iconContainerNext: {
    backgroundColor: ColourPalette.color2,
    color: AppTheme.white,
    width: 40,
    height: 40,
    borderRadius: '50%',
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    right: -55,
    cursor: 'pointer',
  },
  iconContainerPrev: {
    backgroundColor: ColourPalette.color2,
    color: AppTheme.white,
    width: 40,
    height: 40,
    borderRadius: '50%',
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    left: -55,
    cursor: 'pointer',
  },
  imageSliderContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    margin: '20px 0px',
  },
  slider: {
    display: 'flex',
    width: '100%',
    marginTop: 10
  },
  editDialog: {
    minWidth: 465,
    '@media (max-width: 767px)': {
      minWidth: 'unset',
      margin: 15
    }
  },
  editDialogTitle: {
    color: AppTheme.primaryBackground,
    margin: 0,
    fontSize: AppTheme.fontSizeTitle,
    cursor: 'default'
  },
  editDialogContent: {
    backgroundColor: AppTheme.primaryBackground,
    padding: '20px 40px',
    '@media (max-width: 767px)': {
      padding: '20px 10px',
    }
  },
  editInputCss: {
    flex: 1,
    color: AppTheme.white,
    margin: '20px 0px 0px 0px'
  },
  editIncidentTitle: {
    opacity: 0.6,
    color: AppTheme.white,
    fontSize: AppTheme.fontSizeContent,
    margin: '20px 0px 10px 0px',
    cursor: 'default',
    '@media (max-width: 767px)': {
      marginBottom: 0
    }
  },
  editIncidentTag: {
    marginBottom: 0,
  },
  editIncidentType: {
    borderRadius: 4,
    backgroundColor: ColourPalette.color1,
    padding: 5,
    maxWidth: 'fit-content'
  },
  prioritySize: {
    fontSize: 12
  },
  editAlert: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  editAlertContainer: {
    display: 'flex',
    maxWidth: 'fit-content',
    marginRight: 15,
    cursor: 'pointer',
    '@media (max-width: 767px)': {
      marginTop: 10
    }
  },
  editAlertDotContainer: {
    padding: '12px 8px',
    marginRight: 1,
    backgroundColor: AppTheme.primaryColor,
    display: 'flex',
    alignItems: 'center',
  },
  editAlertDotContent: {
    borderRadius: '50%',
    width: 8,
    height: 8
  },
  editAlertLabel: {
    color: AppTheme.white,
    fontSize: 11,
    fontWeight: 'bold',
    padding: 10,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1
  },
  saveButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginTop: 20,
    marginRight: 10
  },
  saveButtonOuterContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
  },
  saveButton: {
    padding: '3px 16px',
    backgroundColor: ColourPalette.color3,
    color: AppTheme.white,
    '@media(max-width: 767px)': {
      padding: '3px 10px',
      fontSize: 12
    }
  },
  outerHeaderStatCard: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: 20,
    paddingLeft: 10,
    paddingRight: 10,
  },
  statContainer: {
    width: '95%',
    backgroundColor: '#11161D',
    border: '1px solid #646871',
    borderRadius: 8,
    padding: 20,
  },
  statContainerTitle: {
    display: 'flex',
    marginBottom: 15
  },
  statTitleImg: {
    width: 24,
    height: 24
  },
  statTitle: {
    margin: 0,
    fontSize: 20,
    color: AppTheme.white,
    marginLeft: 8,
    opacity: .6
  },

  paginationContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  refreshIconContainer: {
    padding: 8,
    ':hover': {
      backgroundColor: AppTheme.secondaryColor,
    }
  },
  refreshIcon: {
    borderRadius: '50%',
    cursor: 'pointer',
    opacity: 0.5,
    color: AppTheme.white,
    ':hover': {
      backgroundColor: '#1D2331',
    }
  },
  pageNumber: {
    opacity: 0.7,
    color: AppTheme.white,
    fontSize: 15
  },
  eventPriorityContainer: {
    display: 'flex'
  },
  reportedPriorityContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },

  statAdjustIcon: {
    height: 18,
    width: 18,
    fontSize: 18,
    minHeight: 18,
    minWidth: 18,
  },
  statAdjustIconContainer: {
    height: 26,
    width: 26,
    fontSize: 26,
    minHeight: 26,
    minWidth: 26,
  },
  emptyEventContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    flex: 1,
  },
  tagsInnerContainer: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  tagsOuterContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  tagContainer: {
    border: '1px solid #354058',
    marginTop: 10,
    marginRight: 8,
    borderRadius: 5,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  tagContainerDetail: {
    border: '1px solid #6c6c6c',
    borderRadius: 5,
  },
  tagKey: {
    backgroundColor: ColourPalette.color1,
    margin: 0,
    color: AppTheme.primaryBackground,
    fontSize: 12,
    fontWeight: 'bold',
    textAlign: 'center',
    padding: 5,
    borderRadius: '4px 0px 0px 4px',
    cursor: 'default'
  },
  tagValue: {
    margin: 0,
    color: '#C7C9CB',
    fontSize: 12,
    fontWeight: 'bold',
    textAlign: 'center',
    padding: 4,
    cursor: 'default'
  },
  progress: {
    color: AppTheme.white,
    margin: '20px 0px'
  },
  searchOuterTextFieldMobile: {
    display: 'none',
    '@media(max-width: 768px)': {
      display: 'flex',
      flexDirection: 'column',
      width: '100%'
    }
  },
  searchTextFieldMobile: {
    display: 'none',
    '@media(max-width: 768px)': {
      display: 'block',
      border: '1px solid #354058',
      borderRadius: 4,
      width: '100%'
    }
  },
  multiPickerForm: {
    '@media(max-width: 768px)': {
      flex: 1
    }
  },
  headerMemberOuterContainer: {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-end',
    alignItems: 'center',
    //opacity: 0.8
    '@media(max-width: 768px)': {
      justifyContent: 'space-between',
      flexDirection: 'column',
      alignItems: 'unset'
    }
  },
  withOpacity: {
    opacity: 0.1
  }
})


// WEBPACK FOOTER //
// ./src/screens/ClientPlace/Styles.js